import { httpClient } from '@/services/http/httpClient'

async function likeIdea(id: string): Promise<void> {
  await httpClient.post(`/ideas/ideas/${id}/like`)
}

export { likeIdea }
